import React, { useState } from "react";
import { Box, useTheme } from "@mui/material";
import Button from "../../components/Button";
import AddIcon from "@mui/icons-material/Add";
import Upload from "@mui/icons-material/Upload";
import { pushErrorMessage } from '../../utils/notifications';
import ActiveProductionOrderDataGrid from "./components/activeProductionOrdersDataGrid";
import Popup from '../../components/Popup';
import { FormattedMessage, useIntl } from "react-intl";
import messages from "./components/messages";
import { tokens } from "../../assets/theme";
import { useQuery } from "@tanstack/react-query";
import CircularProgress from "@mui/material/CircularProgress";
import { useMsal, useAccount } from "@azure/msal-react";
import AxionControls from "../../components/controls/AxionControls";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { fetchProductionItems } from "../../fetchers/productionItems";
import ActivePOUpdateDialog from "./components/activePOUpdateDialog";
import { fetchTools } from "../../fetchers/tools";
import { getActiveProductionOrders } from "../../fetchers/activeProductionOrders";
import { fetchMachines } from "../../fetchers/machine";



const ActiveProductionOrdersIndex = () => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const { accounts } = useMsal();
	const account = useAccount(accounts[0]);
	const [companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);
	const [openPopup, setOpenPopup] = useState(false);
	const [productionOrder, setProductionOrder] = useState({
		activeProductionOrderNumber: null,
		companyKey: companyKey,
		name: "",
		itemNo: "",
		isPriorityItem: false
	});
	const [showBackdrop, setShowBackdrop] = useState(false);
	const [machineId, setMachineId] = useState(null);
	const { formatMessage } = useIntl();
	const [action, setAction] = useState(null); // "start" or "report" or "stop"

	const activeProductionOrdersQuery = useQuery(
		["activeProductionOrders", companyKey],
		() => getActiveProductionOrders(companyKey),
		{
			keepPreviousData: true
		}
	);

	const machineQuery = useQuery(
		["machines", companyKey],
		() => fetchMachines(companyKey),
		{
			keepPreviousData: true
		}
	);

	const productionItemsQuery = useQuery(
		["productionItems", companyKey],
		() => fetchProductionItems(companyKey), {
			keepPreviousData: true
		// staleTime: 60000,
		// refetchInterval: 120000,
	});

		const toolsQuery = useQuery(
			["tools", companyKey],
			() => fetchTools(companyKey),
			{
				staleTime: Infinity,
				keepPreviousData: true
			}
		);

	function getMachineNameById(id) {
		const machine = machineQuery.data?.find((machine) => machine.id === id);
		return machine ? machine.machineName : "";
	}

	const handleEditProductionOrderClick = (id, pAction) => {
		setMachineId(id);
		setAction(pAction);
		setOpenPopup(true);

		// //console.log("Edit production order with machineid: ", id);
		// const productionOrder = activeProductionOrdersQuery.data.find((rowData) => rowData.machineId === id);
		// localProductionOrder = productionOrder;

		// if (productionOrder === undefined || productionOrder === null) {
		//   localProductionOrder = {
		//     erpId: null,
		//     companyKey: companyKey,
		//     machineId: id,
		//     activeProductionOrderNumber: null,
		//     activeTool: null,
		//     idealCycleTime: null,
		//     plannedQuantity: null,
		//     reportedQuantity: null,
		//     remainingQuantity: null,
		//     activeItemId: null,
		//     cavities: 1,
		//     status: "new"
		//   };
		// } else {
		//   localProductionOrder = {
		//     ...productionOrder,
		//     status: "update"
		//   }
		// }

		// console.log("Found production order: ", localProductionOrder);
		// setProductionOrder(localProductionOrder);

	}

	if (activeProductionOrdersQuery === undefined || activeProductionOrdersQuery.data === undefined || activeProductionOrdersQuery.isLoading) {
		return <AxionControls.AxionBackdrop open={true} />
	};
	if (machineQuery === undefined || machineQuery.data === undefined || machineQuery.isLoading) {
		return <AxionControls.AxionBackdrop open={true} />
	};
	if (productionItemsQuery === undefined || productionItemsQuery.data === undefined || productionItemsQuery.isLoading) {
		return <AxionControls.AxionBackdrop open={true} />
	};
	if (toolsQuery === undefined || toolsQuery.data === undefined || toolsQuery.isLoading) {
		return <AxionControls.AxionBackdrop open={true} />
	};

	return (
		<Box maxWidth={1800} >

			<ActiveProductionOrderDataGrid
				productionOrders={activeProductionOrdersQuery}
				machineQuery={machineQuery}
				productionItemsQuery={productionItemsQuery}
				toolsQuery={toolsQuery}
				//handleDeleteProductionOrderClick={handleDeleteProductionOrderClick}
				handleEditProductionOrderClick={handleEditProductionOrderClick}
				setShowBackdrop={setShowBackdrop}
				handleRefreshData={activeProductionOrdersQuery.refetch}

			/>

			<Popup
				openPopup={openPopup}
				setOpenPopup={setOpenPopup}
				maxWidht="sm"
				title={formatMessage(messages.dialogheadding) + getMachineNameById(machineId)}
			>
				<ActivePOUpdateDialog
					machineId={machineId}
					setShowBackdrop={setShowBackdrop}
					handleRefreshData={activeProductionOrdersQuery.refetch}
					setOpenPopup={setOpenPopup}
					action={action}
				/>
			</Popup>
			<AxionControls.AxionBackdrop open={showBackdrop} />
		</Box>

	);
};

export default ActiveProductionOrdersIndex;
